export const MARKETING_SITE_BASE_URL = 'https://www.payscore.com';

export const APP_BASE_URL = 'https://app.payscore.com';

export const STAGING_APP_BASE_URL = 'https://app.staging.payscore.com';

export const COMPANY_NAME = 'Payscore';

export const ADMIN_PORTAL_URL = 'https://app.payscore.com/admin';

export const INSTALL_BROWSER_EXTENSION_URL =
    'https://chromewebstore.google.com/detail/payscore/kcoefldjifkfeclbjicapcenpknedhnf';

export const PRIVACY_POLICY_URL = `${MARKETING_SITE_BASE_URL}/privacy-policy`;

export const TERMS_OF_SERVICE_URL = `${MARKETING_SITE_BASE_URL}/terms-of-service`;

// Support links

export const SUPPORT_URL = 'https://help.payscore.com/en/';

export const ENABLE_COOKIES_URL = `${SUPPORT_URL}articles/13754818-enable-cookies-to-continue-your-verification`;

export const INCOME_DATA_AVAILABILITY_URL = `${SUPPORT_URL}articles/13681512-how-much-income-data-is-included-in-a-payscore-income-report`;
